export const LOGIN_PROVIDER_NAMES = {
  facebook: 'Facebook',
  google: 'Google',
};
